export const silaeLocationsCacheKeys = {
  get_silae_location: () => ['get_silae_location'] as const,
  put_silae_location: () => ['put_silae_location'] as const
}
